export default "__VITE_ASSET__eJ0XnqqH__"